<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <div class="title-box">
            <el-image :src="cheImage" class="title-label"></el-image>
            公司基础信息
          </div>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item prop="companyName" label="公司名称">
                <el-input v-model="form.companyName" clearable autocomplete="off" maxlength="50" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="dutyName" label="负责人姓名">
                <el-input v-model="form.dutyName" clearable autocomplete="off" maxlength="50" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="dutyPhone" label="负责人联系方式">
                <el-input v-model="form.dutyPhone" clearable autocomplete="off" maxlength="11" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-col :span="12">
                <el-form-item prop="city" label="公司地址" required>
                  <el-cascader
                    placeholder="请选择省/市/区"
                    style="width: 100%"
                    :options="options"
                    ref="cascader"
                    v-model="form.city"
                    @change="handleChange"
                    :props="cityProps"></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="12" style="margin-top: 0.32rem">
                <el-form-item prop="address">
                  <el-input
                    v-model="form.address"
                    clearable
                    autocomplete="off"
                    maxlength="30"
                    placeholder="请输入详细地址" />
                </el-form-item>
              </el-col>
            </el-col>
          </el-row>
          <div class="title-box">
            <el-image :src="cheImage" class="title-label"></el-image>
            其他附件
            <span class="color00050">需上传“营业执照、开票资料、合同（PDF）”</span>
          </div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item prop="attachments" label="">
                <UploadFiles :fileType="['pdf']" v-model="form.attachments"></UploadFiles>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import { addInfo, editInfo, detailInfo } from "./api";
import { validatePhone, validatePrice } from "@/utils/validate";
import { getAreaNext } from "@/views/commonApi";
import UploadFiles from "@/components/UploadFiles2.vue";
import {setAreaTree} from "@/utils/index"
export default {
  name: "AddOrEdit",
  components: {
    DialogContainer,
    UploadFiles
  },
  data() {
    return {
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "40%",
        show: false,
        title: "创建代理商",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      // options: JSON.parse(localStorage.getItem("area")),
      cheImage: require("@/assets/imgs/title.png"),
      cityProps: {
        value: "areaCode",
        label: "areaName",
        checkStrictly: true,
      },
      // cityProps: {
      //   lazy: true,
      //   checkStrictly: true, //可选择任意节点
      //   emitPath: true,
      //   lazyLoad(node, resolve) {
      //     const query = node.value ? { code: node.value } : {};
      //     //查询接口
      //     getAreaNext(query).then((res) => {
      //       const nodes = res.data.map((item) => ({
      //         value: item.areaCode,
      //         label: item.areaName,
      //         leaf: item.areaLevel === 2,    // 最后一级是3级（区）
      //         disabled: item.areaLevel !== 2 // 非3级全部禁用（只能选区）
      //       }));
      //       resolve(nodes);
      //     }).catch(() => {
      //       // 接口异常兜底，防止卡死
      //       resolve([]);
      //     });
      //   },
      // },
      form: {
        address: "",
        dutyPhone: "",
        dutyName: "",
        companyName: "",
        attachments: [],
        cityCode: "",
        cityName: "",
        districtCode: "",
        districtName: "",
        provinceCode: "",
        provinceName: "",
        city: [],
      },
      rules: {
        dutyPhone: [
          { required: true, message: "手机号码不能为空" },
          { validator: validatePhone, trigger: "blur" },
        ],
        dutyName: [{ required: true, message: "负责人不能为空" }],
        address: [{ required: true, message: "公司地址不能为空" }],
        companyName: [{ required: true, message: "公司名称不能为空" }],
        city: [{ required: true, message: "省市不能为空" }],
      },
    };
  },
  computed: {
    options: function() {
      let treeData = JSON.parse(localStorage.getItem("area")) || []
      return setAreaTree(treeData, 2)
    }
  },
  mounted() {},
  methods: {
    handleChange() {
      this.form.provinceCode = "";
      this.form.provinceName = "";
      this.form.cityCode = "";
      this.form.cityName = "";
      this.form.districtCode = "";
      this.form.districtName = "";
      const nodes = this.$refs.cascader.getCheckedNodes();
      nodes[0].pathNodes.forEach((node) => {
        if (node.level === 1) {
          this.form.provinceCode = node.value;
          this.form.provinceName = node.label;
        } else if (node.level === 2) {

          this.form.cityCode = node.value;
          this.form.cityName = node.label;
        } else if (node.level === 3) {
          this.form.districtCode = node.value;
          this.form.districtName = node.label;
        }
      });
    },
    async init(row) {
      this.form.city = [];
      if (!!row) {
       await this.getDetail(row.companyId);
        this.dialogObj.title = "编辑代理商"
      } else {
        this.dialogObj.title = "新增代理商"

      }
       this.dialogObj.show = true;
    },
    handleChangePhone() {
      if (!this.form.adminAccount) {
        this.form.adminAccount = this.form.adminPhone;
      }
    },
    setCity(data) {
      let arr = [];
      if (data.districtCode) {
        arr = [data.provinceCode, data.cityCode, data.districtCode];
      } else {
        arr = [data.provinceCode, data.cityCode];
      }
      return arr;
    },
    getDetail(companyId) {
      detailInfo(companyId).then((res) => {
        if (res.code === 200) {
          this.form = { ...res.data };
          this.form.city = [...this.setCity(res.data)]
        }
      });
    },
    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          let methodName = "";
          if (this.form.companyId) {
            methodName = editInfo;
          } else {
            methodName = addInfo;
          }
          const par = {
            companyId: this.form.companyId,
            address: this.form.address,
            adminAccount: this.form.adminAccount,
            dutyName: this.form.dutyName,
            dutyPhone: this.form.dutyPhone,
            attachments: this.form.attachments,
            companyName: this.form.companyName,
            provinceCode: this.form.provinceCode,
            provinceName: this.form.provinceName,
            cityCode: this.form.cityCode,
            cityName: this.form.cityName,
            districtCode: this.form.districtCode,
            districtName: this.form.districtName,
          };
          methodName(par)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success(
                  this.form.companyId ? "编辑成功" : "保存成功"
                );
                this.$parent.handleAddOrEditSuccess(
                  this.form.companyId ? "edit" : "add"
                );
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .left-box {
    padding-right: 0.5rem;
    padding-bottom: 0.1rem;
    position: relative;
    display: flex;
    align-items: center;
    .left-box-top {
      display: flex;
      align-items: center;
      .label {
        width: 0.2rem;
        height: 0.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0.02rem;
        font-size: 0.12rem;
      }
      .zhuang {
        color: #5cc41a;
        background-color: rgba(92, 196, 26, 0.3);
      }
      .xie {
        color: #e52019;
        background-color: rgba(229, 32, 25, 0.3);
      }
      .name {
        color: #000000;
        font-size: 0.18rem;
        line-height: 0.2rem;
        padding-left: 0.04rem;
      }
    }
    .date {
      color: #8c8c8c;
      font-size: 0.12rem;
      line-height: 0.2rem;
    }
  }
  .left-box:nth-last-of-type(1)::before {
    display: none;
  }
  .car-img {
    width: 0.1rem;
    height: 0.1rem;
    margin-right: 0.04rem;
  }
  .center-box-2 {
    display: flex;
    align-items: center;
    line-height: 0.24rem;
    color: #000000;
    font-size: 0.12rem;
    position: relative;
  }
  .center-box-2 {
    padding-left: 0.2rem;
    position: relative;
    &::before {
      content: "";
      width: 0.01rem;
      height: 0.1rem;
      background-color: #dce5f5;
      position: absolute;
      left: 0.1rem;
    }
  }
  .center-box-1 {
    color: #1269ff;
  }
  .title-box {
    padding: 0rem 0 0.1rem;
    .title-label {
      width: 0.08rem;
      height: 0.08rem;
      margin-right: 0.06rem;
    }
  }
  .tip {
    font-size: 0.12rem;
    padding-left: 0.1rem;
    color: #999999;
  }
}
</style>
